import React, { Fragment } from "react";
import ModalComponent from "@/components/modal";
import GuideForm from "@/pages/guide/GuideForm";
import "@/styles/pages/auth/set-preferences.scss";
import { setPreferences } from "@/services/users/setPreferences";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentForm,
  setFormProps,
  setIsLoggedIn,
  setModalOpen,
} from "@/reducers/commonSlice";
import { getGuideListBasedOnFilter } from "@/services/services/getGuideListBasedOnFilter";
import { setFilteredGuide } from "@/reducers/guideSlice";
import {
  getIsCheckoutToShow,
  getIsProductRegisterSuccessToShow,
  getRegisterProdutId,
  setIsProductRegisterSuccessToShow,
} from "@/reducers/checkoutSlice";
import { registerProducts } from "@/services/services/registerProducts";

const SetPrefrences = ({ isOpen = false }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isCheckoutToShow = useSelector(getIsCheckoutToShow);
  const isProductRegisterSuccessToShow = useSelector(getIsProductRegisterSuccessToShow);
  const registerProductId = useSelector(getRegisterProdutId);

  const handleFinish = (value) => {
    const data = {
      ...value,
      levelIds: !!value.levelIds ? [value.levelIds] : [],
    };
    setPreferences(data)
      .then((response) => {
        console.log(response);
        getGuideListBasedOnFilter(data)
          .then((res) => {
            dispatch(setFilteredGuide(res));
            dispatch(setModalOpen(false));
            dispatch(setIsLoggedIn(true));
            if (isProductRegisterSuccessToShow && registerProductId) {
              registerProducts({
                productId: registerProductId,
              })
                .then((res) => {
                  dispatch(setCurrentForm("productSuccess"));
                  dispatch(setModalOpen(true));
                  dispatch(
                    setFormProps({
                      message: "Your interest was registered",
                      subMessage: "Team will contact you shortly",
                      onSubmit: () => {
                        dispatch(setModalOpen(false));
                        dispatch(setIsProductRegisterSuccessToShow(false));
                      },
                    })
                  );
                })
                .catch((err) => console.log(err));
            } else if (isCheckoutToShow) {
              navigate("/checkout-preview");
            } else {
              if (window.location.pathname.includes("membership")) {
                navigate("/membership");
              } else {
                navigate("/guide-list");
              }
            }
          })
          .catch((error) => console.log(error));
      })
      .catch((error) => console.log(error));
  };
  return (
    <Fragment>
      <ModalComponent
        buttonLabel="Create Account"
        isOpen={isOpen}
        width={800}
        maskClosable={false}
        className="onboarding-modal"
      >
        <GuideForm
          handleFinish={handleFinish}
          title="Where and what do you want to study abroad?"
          subtitle=""
          isOnBoarding
          className="setPrefrences-form"
        />
      </ModalComponent>
    </Fragment>
  );
};

export default SetPrefrences;
